import React from "react";
import { useLocation } from "react-router-dom";

const MailTemplate = () => {
  // const [template, setTemplate] = useState(null);
  const location = useLocation();
  const { template } = location.state || {};
  console.log(template)

  return (
    <div>
      <div className="w-12/12 flex flex-col gap-3   p-4 border bg-customLightGrayishYellow rounded-lg">
        <div className=" flex gap-1">
          <h2 className="font-bold">Subject:</h2>

          <div
            className="template-content"
            dangerouslySetInnerHTML={{ __html: template.subject }}
          />        </div>
        <div className="border-t-2 border-slate-400  mx-2"></div>
        <div>
            <div className="flex flex-col gap-2">
          <h2 className="font-bold">Content:</h2>
                
          <div
            className="template-content"
            dangerouslySetInnerHTML={{ __html: template.content }}
          />
        </div>
        </div>

      </div>
    </div>
  );
};

export default MailTemplate;
